"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setClauseType')(function setClauseType(clauseType, clauseId) {
    store_1.default.inboxRulesEditState.clauseMap.get(clauseId).clauseType = clauseType;
});
//# sourceMappingURL=setClauseType.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/setClauseType.js
// module id = 5203
// module chunks = 2